(() => {
  if (window.moveSmartHomepageReady) return;
  window.moveSmartHomepageReady = true;
  let seed = Math.floor(Math.random() * 2147483647);
  try {
    const saved = sessionStorage.getItem('movesmart-picks-seed');
    if (saved && /^\d+$/.test(saved)) seed = Number(saved);
    else sessionStorage.setItem('movesmart-picks-seed', String(seed));
  } catch (_) {}
  const score = id => {
    let h = seed >>> 0;
    for (const c of id) h = Math.imul(h ^ c.charCodeAt(0), 16777619) >>> 0;
    h ^= h >>> 16; h = Math.imul(h, 0x85ebca6b); h ^= h >>> 13;
    return h >>> 0;
  };
  const fitProductImage = card => {
    const image = card.querySelector('.msh__product-image img');
    if (!image || image.dataset.mshImageFitReady) return;
    image.dataset.mshImageFitReady = 'true';

    const fit = () => {
      if (!image.naturalWidth || !image.naturalHeight) return;
      try {
        const sampleSize = 96;
        const canvas = document.createElement('canvas');
        canvas.width = sampleSize;
        canvas.height = sampleSize;
        const context = canvas.getContext('2d', { willReadFrequently: true });
        context.drawImage(image, 0, 0, sampleSize, sampleSize);
        const pixels = context.getImageData(0, 0, sampleSize, sampleSize).data;
        const cornerSize = 4;
        let red = 0;
        let green = 0;
        let blue = 0;
        let cornerPixels = 0;

        for (let y = 0; y < sampleSize; y += 1) {
          for (let x = 0; x < sampleSize; x += 1) {
            const inCorner = (x < cornerSize || x >= sampleSize - cornerSize)
              && (y < cornerSize || y >= sampleSize - cornerSize);
            if (!inCorner) continue;
            const offset = (y * sampleSize + x) * 4;
            if (pixels[offset + 3] < 16) continue;
            red += pixels[offset];
            green += pixels[offset + 1];
            blue += pixels[offset + 2];
            cornerPixels += 1;
          }
        }

        if (!cornerPixels) return;
        const background = [red / cornerPixels, green / cornerPixels, blue / cornerPixels];
        const columns = new Uint16Array(sampleSize);
        const rows = new Uint16Array(sampleSize);

        for (let y = 0; y < sampleSize; y += 1) {
          for (let x = 0; x < sampleSize; x += 1) {
            const offset = (y * sampleSize + x) * 4;
            if (pixels[offset + 3] < 24) continue;
            const difference = Math.max(
              Math.abs(pixels[offset] - background[0]),
              Math.abs(pixels[offset + 1] - background[1]),
              Math.abs(pixels[offset + 2] - background[2])
            );
            if (difference > 22) {
              columns[x] += 1;
              rows[y] += 1;
            }
          }
        }

        const firstSignificant = counts => counts.findIndex(count => count >= 2);
        const lastSignificant = counts => {
          for (let index = counts.length - 1; index >= 0; index -= 1) {
            if (counts[index] >= 2) return index;
          }
          return -1;
        };
        const left = firstSignificant(columns);
        const right = lastSignificant(columns);
        const top = firstSignificant(rows);
        const bottom = lastSignificant(rows);
        if (left < 0 || right < left || top < 0 || bottom < top) return;

        const frame = card.querySelector('.msh__product-image');
        const frameRatio = frame.clientWidth / Math.max(frame.clientHeight, 1);
        const imageRatio = image.naturalWidth / image.naturalHeight;
        const fittedWidth = imageRatio > frameRatio ? 1 : imageRatio / frameRatio;
        const fittedHeight = imageRatio > frameRatio ? frameRatio / imageRatio : 1;
        const contentWidth = ((right - left + 1) / sampleSize) * fittedWidth;
        const contentHeight = ((bottom - top + 1) / sampleSize) * fittedHeight;
        const occupied = Math.max(contentWidth, contentHeight);
        const scale = Math.min(1.18, Math.max(1, 0.88 / Math.max(occupied, 0.01)));
        card.style.setProperty('--msh-product-image-scale', scale < 1.025 ? '1' : scale.toFixed(3));
      } catch (_) {
        card.style.setProperty('--msh-product-image-scale', '1');
      }
    };

    if (image.complete) fit();
    else image.addEventListener('load', fit, { once: true });
  };
  function init(root = document) {
    root.querySelectorAll('[data-msh-pool]').forEach(pool => {
      if (pool.dataset.ready) return;
      pool.dataset.ready = 'true';
      const seen = new Set();
      const cards = Array.from(pool.children).filter(card => {
        const id = card.dataset.productId;
        if (seen.has(id)) { card.hidden = true; return false; }
        seen.add(id); return true;
      });
      const ordered = pool.dataset.vary === 'true' && pool.dataset.editor !== 'true'
        ? cards.slice().sort((a,b) => score(a.dataset.productId) - score(b.dataset.productId)) : cards;
      const selected = new Set(ordered.slice(0, 6));
      cards.forEach(card => {
        card.hidden = !selected.has(card);
        if (!card.hidden) fitProductImage(card);
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-msh-reviews]').forEach(mount => {mount._mshObserver?.disconnect();mount._mshCleanup?.();}));
})();

